export class Produto {
  private id:         number;
  private _numero:    number;
  private cod_barra:  string;
  private preco_ger:  number;
  private preco_cv:   number;
  private grupo:      number;

  constructor (private encarte) {
    this.numero = encarte
  }

  get numero() {
    return this._numero;
  }

  set numero(value: number) {
    this._numero = value;
  }

  public toJSON() {
    return {
      id:        this.id,
      numero:    this.numero,
      cod_barra: this.cod_barra,
      preco_ger: this.preco_ger,
      preco_cv:  this.preco_cv,
      grupo:     this.grupo
    }
  }

  public toClass(produto) {
    this.id        = produto.id;
    this.numero    = produto.numero;
    this.cod_barra = produto.cod_barra;
    this.preco_ger = produto.preco_ger;
    this.preco_cv  = produto.preco_cv;
    this.grupo     = produto.grupo;
  }
}
